module.exports = __webpack_public_path__ + "static/img/9.358546c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/9.png
// module id = g1jG
// module chunks = 0